var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isPending
        ? _c("confirm-email", { attrs: { email: _vm.email } })
        : _c("div", { staticClass: "login-container" }, [
            _c("div", { staticClass: "row p-sm bg-color-login" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "text-center" }, [
                  _c("h4", [_vm._v("パスワードをリセットする")])
                ]),
                _vm._v(" "),
                _vm.err
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _c("span", {
                        attrs: { id: "message" },
                        domProps: { innerHTML: _vm._s(_vm.err) }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "hpanel" }, [
                  _c("div", { staticClass: "panel-body" }, [
                    _c("div", [
                      _c("span", [_vm._v("パスワードをお忘れの場合は、")]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [_vm._v("以下にメールアドレスを入力し、")]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("「パスワードをリセットする」ボタンを押して、")
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [_vm._v("メールを送って下さい。")])
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label label-normal",
                          attrs: { for: "email" }
                        },
                        [_vm._v("メールアドレス")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email|max:150",
                            expression: "'required|email|max:150'"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          name: "email",
                          id: "email",
                          "data-vv-as": "メールアドレス"
                        },
                        domProps: { value: _vm.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("email"),
                              expression: "errors.has('email')"
                            }
                          ],
                          staticClass: "text-danger",
                          staticStyle: { display: "block" }
                        },
                        [_vm._v("※" + _vm._s(_vm.errors.first("email")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-warning btn-block",
                        on: { click: _vm.resetPassword }
                      },
                      [_vm._v("パスワードをリセットする")]
                    )
                  ])
                ])
              ])
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af5cf718", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af5cf718","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/resetpassword/ResetPassword.vue
// module id = null
// module chunks = 